export default __webpack_public_path__ + "88bf652ad4fb874f56a1f7d4452cc344.jpg";